module.exports = __webpack_public_path__ + "static/media/01_c_photo.45077d46.jpg";